<template>
  <div>
    <excel-export :filename="utils.getNowFormatDate()+btn.filename" :sheet="btn.sheet" border>
      <el-button><img style="width: 12px; height:12px;margin-right:5px" v-if="btn.btnIcon" :src="btn.btnIcon">{{btn.btnLabel}}</el-button>
    </excel-export>
  </div>
</template>
<script>
  export default {
    name: "btnExcel",
    props: {
      btn: {
        type: Object,
        default: {}
      },
    },
    data: function() {
      return {}
    },
    /* computed: {
    }, */
    methods: {},
    mounted() {
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/button/btnExcel.vue